export default __webpack_public_path__ + "static/media/queen1.de41211a.png";